// import LocalizationStore from '../Stores/LocalizationStore'

export interface IScheduleConfig {
    id: string
    name: string
    calculatePrepayment: boolean
    values: number[][]
}

export class ScheduleConfig {
    constructor(
        id: string = "default",
        name: string = "default",
        calculatePrepayment: boolean = false,
        values: number[][] = []
    ) {
        this.id = id
        this.calculatePrepayment = calculatePrepayment
        this.name = name
        this.values = values
    }

    id: string
    name: string
    calculatePrepayment: boolean
    values: number[][]
}

// const ls = LocalizationStore.getInstance()


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/ScheduleConfig.tsx